<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild" :class="{ scrolled: isScrolled }">
    <!-- 头部顶部 -->
    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>888-888-888
          <span class="glyphicon glyphicon-envelope"></span>xxx@163.com
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div> -->
    <!-- <div class="header-logo">
      <div class="logo-item">
        <div class="logo-icon1 logo-icon"></div>
        <div class="logo-box">
          <img
            class="logo-img"
            src="@/assets/img/xcx1.png"
            loading="lazy"
          /><img class="logo-img" src="@/assets/img/xcx2.jpg" loading="lazy" />
        </div>
      </div>
      <div class="logo-item">
        <div class="logo-icon2 logo-icon"></div>
        <div class="logo-box">
          <img class="logo-img" src="@/assets/img/wx1.jpg" loading="lazy" /><img
            class="logo-img"
            src="@/assets/img/wx2.jpg"
            loading="lazy"
          />
        </div>
      </div>
    </div> -->
    <!-- 电脑导航 -->
    <div class="header-nav hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo" @click="toHome">
        <img
          :src="hearderLogo || require('@/assets/img2/penyan_logo.png')"
          loading="lazy"
        />
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item.title, item.id, item.id2)"
        >
          <a>
            {{ item.title }}
          </a>
          <!-- 二级导航 -->
          <dl
            v-if="index != 0 && item.childList && item.childList.length > 0"
            class="sub-nav"
          >
            <dt
              v-for="(child, childIndex) in item.childList"
              :key="childIndex"
              @click.stop="
                navChildClick(
                  index,
                  item.id,
                  item.id2,
                  child.title,
                  child.id,
                  item.type,
                  child.url
                )
              "
            >
              <a>{{ child.title }}</a>
            </dt>
          </dl>
        </li>
        <li>
          <div class="header-logo">
            <div class="logo-item">
              <div class="logo-icon1 logo-icon"></div>
              <div class="logo-box">
                <img
                  class="logo-img1"
                  src="@/assets/img/xcx1.jpg"
                  loading="lazy"
                /><img
                  class="logo-img2"
                  src="@/assets/img/xcx2.jpg"
                  loading="lazy"
                />
              </div>
            </div>
            <div class="logo-item">
              <div class="logo-icon2 logo-icon"></div>
              <div class="logo-box">
                <img
                  class="logo-img1"
                  src="@/assets/img/wx1.jpg"
                  loading="lazy"
                /><img
                  class="logo-img2"
                  src="@/assets/img/wx2.jpg"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img
          class="center-block"
          src="@/assets/img2/LOGO.png"
          loading="lazy"
          alt="logo"
        />
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.title, item.id, item.id2)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <a>
              {{ item.title }}
              <i class="underline"></i>
            </a>
            <!-- <router-link :to="item.id">
              {{ item.title }}
              <i class="underline"></i>
            </router-link> -->
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { getInfo } from "@/api/api";
export default {
  name: "Header",
  data() {
    return {
      isScrolled: false, // 判断是否滚动过
      hearderLogo: "",
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "走进鹏雁",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "新闻中心",
          path: "/software",
          children: []
        },
        {
          name: "多元鹏雁",
          path: "/service",
          children: []
        },
        {
          name: "社会责任",
          path: "/newsinformation",
          children: []
        },
        {
          name: "加入鹏雁",
          path: "/companyintroduction",
          children: []
        }
      ]
    };
  },
  mounted() {
    this.getIndex();
  },
  methods: {
    getIndex(data) {
      getInfo({ id: data }).then(response => {
        this.navList = response.data.data.columnList;
        this.hearderLogo = response.data.data.logo;
      });
    },
    toHome() {
      this.navClick(0, "", "", 0);
    },
    navClick(index, title, id, id2) {
      if (id == 99) {
        return;
      }
      if (id == 1) {
        this.$router.push({
          path: "/home"
        });
        this.navIndex = index;
        sessionStorage.setItem("navIndex", index);
        this.menuName = title;
        return;
      }
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = title;
      if (id2 == 0 || id == null || id2 == "" || !id2) {
        this.$router.push("/");
      } else {
        this.$router.push({
          path: "/software",
          query: {
            id: id,
            id2: id2
          }
        });
      }
    },
    navChildClick(index, id, id2, title, childId, type, url) {
      if (type === "link") {
        window.open(url, "_blank");
        return;
      }
      if (this.navIndex !== index) {
        this.navIndex = index;
        sessionStorage.setItem("navIndex", index);
      }
      this.menuName = title;
      // 获取当前的路由路径和查询参数
      const currentPath = this.$route.fullPath;
      const targetPath = `/software?id=${id}&id2=${id2}&childId=${childId}`;

      // 如果目标路径与当前路径不同，则进行跳转
      if (currentPath !== targetPath) {
        this.$router
          .push({
            path: "/software",
            query: {
              id: id,
              id2: id2,
              childId: childId
            }
          })
          .catch(err => {
            // 捕获并忽略 NavigationDuplicated 错误
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      // this.$router.push({
      //   path: "/software",
      //   query: {
      //     id: id,
      //     id2: id2,
      //     childId: childId
      //   }
      // });
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #fff;
  transition: all ease 0.6s;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}
.header-logo {
  width: 100px;
  height: 110px;
  /* max-width: 1200px;
  min-width: 960px;
  margin: 0 auto; */
  display: flex;
  align-items: center;
  justify-content: space-around;
  box-sizing: border-box;
  /* padding-top: 10px; */
}
.logo-item {
  /* padding: 0 20px; */
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.logo-icon {
  width: 30px;
  height: 30px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.logo-icon:hover {
  cursor: pointer;
}
.logo-icon1 {
  background-image: url("~@/assets/img/xcx1.svg");
}
.logo-icon2 {
  background-image: url("~@/assets/img/wx1.svg");
}
.logo-icon1:hover {
  background-image: url("~@/assets/img/xcx2.svg");
}
.logo-icon2:hover {
  background-image: url("~@/assets/img/wx2.svg");
}
.logo-box {
  position: absolute;
  bottom: -120px;
  left: calc(50% - 120px);
  width: 240px;
  height: 120px;
  padding: 10px;
  /* display: flex;
  justify-content: space-between;
  align-items: center; */
  z-index: 100;
  background-color: #fff;
  display: none;
}
.logo-img1 {
  display: block;
  width: 100px;
  height: 100px;
  object-fit: cover;
  float: left;
}
.logo-img2 {
  display: block;
  width: 100px;
  height: 100px;
  object-fit: cover;
  float: right;
}

.logo-icon:hover + .logo-box {
  display: block;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  max-width: 1400px;
  min-width: 1200px;
  height: 110px;
  display: flex;
  align-items: center;
  /* overflow: hidden; */
  justify-content: space-between;
  margin: 0 auto;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 325px;
  height: 100%;
  /* float: left; */
  /* position: relative; */
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 100%;
  height: 65px;
}
/* 导航栏 导航容器 */
/* #header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
} */
#header .header-nav .header-nav-wrapper {
  flex: 1;
  height: 100%;
  line-height: 110px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* max-width: 800px; */
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  flex: 1;
  height: 100%;
  text-align: center;
  box-sizing: border-box;
  padding: 0 10px;
  position: relative;
  cursor: pointer;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 16px;
  text-align: center;
  width: 100%;
  height: 100%;
  line-height: 110px;
  position: relative;
  color: #000;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  /* color: #1e73be; */
  text-decoration: none;
  color: #fb8c00;
  font-weight: bold;
  /* background-color: #fb8c00; */
  /* padding: 46px; */
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #fb8c00;
  text-decoration: none;
  font-weight: bold;
  /* border-bottom: 2px solid #1e73be; */
  /* background-color: #fb8c00; */
  /* padding: 46px; */
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 150%;
  top: 110px;
  z-index: 999999;
  /* box-shadow: 0 0 3px 1px #ccc; */
  background: rgba(202, 177, 177, 0.6);
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  line-height: 40px;
  color: #ffffff;
  text-align: left;
  font-size: 14px;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a {
  display: block;
  text-align: left;
  padding: 5px 20px;
  text-decoration: none;
  color: #ffffff;
}
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  color: #fff;
  background: #00afcc;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: auto;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue